export const emptyMessageReply = {
  referenceId: undefined,
  referenceText: '',
  referenceName: '',
  scrollingTo: undefined,
}

export default emptyMessageReply
